// Centralized Google Maps config with robust resolution and local fallback

function resolveEnvKey(): string | undefined {
  const env = (import.meta as any)?.env || {};
  const candidates = [
    env.VITE_GOOGLE_MAPS_API_KEY,
    env.VITE_MAPS_API_KEY,
    env.VITE_GOOGLE_MAPS_KEY,
    env.VITE_GOOGLE_API_KEY,
  ];
  const fromEnv = candidates.find((v: any) => typeof v === 'string' && v.trim().length > 0);
  if (fromEnv) return fromEnv.trim();

  try {
    const fromStorage = localStorage.getItem('teakonn-maps-key');
    if (fromStorage && fromStorage.trim()) return fromStorage.trim();
  } catch {}

  if (typeof window !== 'undefined' && (window as any).__TEAKONN_MAPS_API_KEY) {
    const w = (window as any).__TEAKONN_MAPS_API_KEY;
    if (typeof w === 'string' && w.trim()) return w.trim();
  }

  return undefined;
}

export const MAPS_API_KEY: string | undefined = resolveEnvKey();

export function setMapsApiKey(key: string) {
  try {
    localStorage.setItem('teakonn-maps-key', key);
  } catch {}
}

// Only request libraries we actually use
export const MAP_LIBRARIES: ("places" | "marker")[] = ["places", "marker"]; 

function resolveMapId(): string | undefined {
  const env = (import.meta as any)?.env || {};
  const candidates = [
    env.VITE_GOOGLE_MAP_ID,
    env.VITE_MAP_ID,
  ];
  const fromEnv = candidates.find((v: any) => typeof v === 'string' && v.trim().length > 0);
  if (fromEnv) return (fromEnv as string).trim();
  try {
    const fromStorage = localStorage.getItem('teakonn-maps-mapid');
    if (fromStorage && fromStorage.trim()) return fromStorage.trim();
  } catch {}
  return undefined;
}

export const MAP_ID: string | undefined = resolveMapId();

function resolveUseOsmOnly(): boolean {
  const env = (import.meta as any)?.env || {};
  const flag = env.VITE_USE_OSM_ONLY;
  if (typeof flag === 'string') {
    const v = flag.trim().toLowerCase();
    if (v === 'true' || v === '1' || v === 'yes') return true;
  }
  try {
    const ls = localStorage.getItem('teakonn-maps-use-osm-only');
    if (ls && ls.trim()) {
      const v = ls.trim().toLowerCase();
      return v === 'true' || v === '1' || v === 'yes';
    }
  } catch {}
  return false;
}

export const USE_OSM_ONLY: boolean = resolveUseOsmOnly();

export function setMapId(id: string) {
  try {
    localStorage.setItem('teakonn-maps-mapid', id);
  } catch {}
}

export function setUseOsmOnly(flag: boolean) {
  try {
    localStorage.setItem('teakonn-maps-use-osm-only', String(flag));
  } catch {}
}